module.exports = {
  CUR_TIME   : "20260928_115446",
  VERSION    : "m-v0.90.9-94",
  GIT_HASH   : "6735908f9f",
  GIT_BRANCH : "HEAD",
  GIT_TAG    : "0.90.9",
  PKG_NAME   : "clearing_portal",
  APP_NAME   : "ClearingPortal"
}
